/*=========================================================================================
File Name: AboutArea.vue
Description: About Page Area Component.
Version: 1.0
----------------------------------------------------------------------------------------
Item Name: V-Pizzle - VueJS Pizza & Fast Food Template
Author: Deveable
Author URL: https://www.templatemonster.com/authors/deveable/
Copyright 2021
==========================================================================================*/

<template>
  <!-- About Area Start -->
  <section class="about_area">
    <img src="../assets/img/shape23.png" alt="shape" class="about_shape"/>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="about_left">
            <h3 class="sub_title">Who we area</h3>
            <h2 class="section_title">Story About Us</h2>
            <img src="../assets/img/section_delimiter.png" alt="img" class="section_devider">
            <br>
            <br>
            <p><b>Nullam rutrum nibh mauris, at tempus nulla laoreet non. Proin laoreet vehicula justo vel
              tincidunt.</b> Donec maximus vitae nibh at ultricies. Lorem ipsum dolor sit amet, consectetur adipiscing
              elit.</p>
            <p>Aenean tristique tristique odio vitae imperdiet. Cras eu mi lectus. Nulla quis feugiat tortor. Donec
              turpis tortor, lacinia eget nulla quis, semper viverra elit. Pellentesque habitant morbi tristique
              senectus et netus et malesuada fames ac turpis egestas.</p>
            <p>Proin id tempor ipsum. Nulla eu nisi tincidunt, iaculis purus ac, molestie orci. Maecenas est leo,
              dapibus vel purus a, commodo semper elit. Aenean tempus accumsan enim tincidunt eleifend.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="about_right">
            <div class="about_img">
              <img src="../assets/img/about.png" alt="img"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- About Area End -->
</template>
<script>
export default {
  name: 'AboutArea'
}
</script>



// WEBPACK FOOTER //
// src/components/AboutArea.vue